// AMS-5593：与 micro-union/NS_basicConfiguration/utils/serviceSidebarTheme.js 保持一致。
// 仅派生服务平台侧栏的局部变量，不修改官网/后台的全局主题。
function readColor(value) {
  if (typeof value !== 'string') return null
  const color = value.trim()
  const hex = /^#([\da-f]{3}|[\da-f]{6})$/i.exec(color)
  if (hex) {
    const text = hex[1].length === 3 ? hex[1].split('').map(char => char + char).join('') : hex[1]
    return [0, 2, 4].map(index => parseInt(text.slice(index, index + 2), 16))
  }
  // 兼容旧模板中保存的 RGB；透明色及 CSS 表达式不作为侧栏主题。
  const rgb = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i.exec(color)
  return rgb && rgb.slice(1).every(channel => Number(channel) <= 255) ? rgb.slice(1).map(Number) : null
}

export function cssColor(color) { return `rgb(${color.join(', ')})` }
export function mixWhite(color, strength) { return color.map(channel => Math.round(255 + (channel - 255) * strength)) }
function luminance(color) {
  const channels = color.map(channel => {
    const value = channel / 255
    return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4)
  })
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722
}
export function contrast(first, second) {
  const a = luminance(first)
  const b = luminance(second)
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05)
}

// 与评审 HTML 的 B 方案一致：保持原色方向，按需加深，实心控件始终用白字。
function deepenFor(color, background, target = 5.2) {
  let result = color.slice()
  for (let step = 0; step < 256 && contrast(result, background) < target; step++) {
    result = result.map(channel => Math.max(0, Math.floor(channel * 0.98)))
  }
  return result
}

export function servicePalette(brand) {
  const action = deepenFor(brand, [255, 255, 255])
  return {
    brand: brand.slice(),
    action,
    hover: action.map(channel => Math.floor(channel * 0.92)),
    pressed: action.map(channel => Math.floor(channel * 0.82)),
    ink: deepenFor(brand, mixWhite(brand, 0.14)),
    disabled: brand.map((channel, index) => {
      const neutral = [245, 246, 248][index]
      return Math.round(neutral + (channel - neutral) * 0.07)
    })
  }
}

export function serviceSidebarTheme(raw) {
  let style = raw
  if (typeof style === 'string') {
    try { style = JSON.parse(style) } catch (e) { style = null }
  }
  const object = style && typeof style === 'object' && !Array.isArray(style) ? style : {}
  // 与 PC 官网旧 extra 格式一致：extra 中的 GLOBAL_COLOR 优先。
  const extra = object.extra && typeof object.extra === 'object' && !Array.isArray(object.extra) ? object.extra : {}
  const color = readColor(extra.GLOBAL_COLOR !== undefined ? extra.GLOBAL_COLOR : object.GLOBAL_COLOR)
  const accent = color || [22, 93, 255]
  const palette = servicePalette(accent)
  const title = color ? palette.action : deepenFor([4, 90, 213], [255, 255, 255])
  const activeBackground = mixWhite(accent, 0.1)
  return {
    configured: !!color,
    palette,
    activeText: cssColor(palette.ink),
    variables: {
      '--service-sidebar-title-bg': cssColor(title),
      '--service-sidebar-title-text': '#fff',
      '--service-sidebar-active-text': cssColor(palette.ink),
      '--service-sidebar-active-bg': cssColor(activeBackground),
      '--service-sidebar-hover-bg': cssColor(mixWhite(accent, 0.06)),
      '--service-sidebar-surface': cssColor(mixWhite(accent, 0.04)),
      '--service-sidebar-tail': cssColor(mixWhite(accent, 0.08))
    }
  }
}
